'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite$002dScope$0024$0024anon$0024121 from "./presto.types$-Site-Scope$$anon$121.js";
import * as $j_presto$002etypes$0024$002dSite$002dScope$0024$0024anon$0024122 from "./presto.types$-Site-Scope$$anon$122.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SiteScope$() {
  this.cb9 = null;
  this.cba = false;
  this.cb7 = null;
  this.cb8 = false;
  this.cbd = null;
  this.cbe = false;
  this.cbb = null;
  this.cbc = false;
  this.cbf = null;
  this.cbg = false;
}
export { $c_Lpresto_types$SiteScope$ as $c_Lpresto_types$SiteScope$ };
$p = $c_Lpresto_types$SiteScope$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SiteScope$;
/** @constructor */
function $h_Lpresto_types$SiteScope$() {
}
export { $h_Lpresto_types$SiteScope$ as $h_Lpresto_types$SiteScope$ };
$h_Lpresto_types$SiteScope$.prototype = $p;
$p.cHM = (function() {
  if ((!this.cba)) {
    this.cb9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.cba = true;
  }
  return this.cb9;
});
$p.iQ = (function() {
  if ((!this.cb8)) {
    this.cb7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.cb8 = true;
  }
  return this.cb7;
});
$p.cIh = (function() {
  if ((!this.cbe)) {
    this.cbd = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.cbe = true;
  }
  return this.cbd;
});
$p.cI4 = (function() {
  if ((!this.cbc)) {
    this.cbb = new $j_presto$002etypes$0024$002dSite$002dScope$0024$0024anon$0024121.$c_Lpresto_types$SiteScope$$anon$121(this);
    this.cbc = true;
  }
  return this.cbb;
});
$p.ady = (function() {
  if ((!this.cbg)) {
    this.cbf = new $j_presto$002etypes$0024$002dSite$002dScope$0024$0024anon$0024122.$c_Lpresto_types$SiteScope$$anon$122(this);
    this.cbg = true;
  }
  return this.cbf;
});
var $d_Lpresto_types$SiteScope$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteScope$, "presto.types$SiteScope$", ({
  a2k: 1,
  D: 1
}));
export { $d_Lpresto_types$SiteScope$ as $d_Lpresto_types$SiteScope$ };
var $n_Lpresto_types$SiteScope$;
function $m_Lpresto_types$SiteScope$() {
  if ((!$n_Lpresto_types$SiteScope$)) {
    $n_Lpresto_types$SiteScope$ = new $c_Lpresto_types$SiteScope$();
  }
  return $n_Lpresto_types$SiteScope$;
}
export { $m_Lpresto_types$SiteScope$ as $m_Lpresto_types$SiteScope$ };
//# sourceMappingURL=presto.types$-Site-Scope$.js.map
